<template>
  <div
    class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
    v-show="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <form class="validate-form" @submit.prevent="handleSave" v-if="!loading">
    <div>
      <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <ListIcon />
        <h2 class="text-lg font-medium mr-auto">
          {{ $t('category.edit') }}<span v-if="title !== ''"> - {{ title }}</span>
        </h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <button type="submit" class="btn btn-primary shadow-md flex items-center">
            <SaveIcon class="w-4 h-4 mr-2" /> {{ $t('common.save') }}
          </button>
          <router-link
            :to="{ name: 'superadmin-tools-category' }"
            tag="a"
            class="btn shadow-md flex items-center"
          >
            <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
          </router-link>
        </div>
      </div>
      <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
        <div class="col-span-12">
          <div class="intro-y box p-5">
            <div class="mt-3">
              <label
                for="customTitle"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('category.customTitle') }}
              </label>
              <input
                id="customTitle"
                v-model.trim="customTitle"
                type="text"
                class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
              />
            </div>
            <div class="mt-3">
              <label
                for="metaDescription"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('category.metaDescription') }}
              </label>
              <input
                id="metaDescription"
                v-model.trim="metaDescription"
                type="text"
                class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
              />
            </div>
            <div class="mt-3">
              <label
                for="customContent"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('category.customContent') }}
              </label>
              <TuiEditor
                ref="editorContentRef"
                v-model="editorContent"
                :options="editorOptions"
                height="300px"
                :theme="editorTheme"
                initial-edit-type="markdown"
              />
            </div>
            <div class="mt-3">
              <label
                for="customFooter"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('category.customFooter') }}
              </label>
              <TuiEditor
                ref="editorFooterRef"
                v-model="editorFooter"
                :options="editorOptions"
                height="300px"
                :theme="editorTheme"
                initial-edit-type="markdown"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('category.edited') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('category.notEdited') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('category.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import Toastify from 'toastify-js'
import categoryApi from '@/services/branch-categories/branch-category.api'
import TuiEditor from '@/components/editor/TuiEditor.vue'

export default defineComponent({
  components: {
    TuiEditor
  },
  methods: {
    handleSave(data) {
      this.loading = true

      const saveRequest = {
        lang: this.$route.params.lang,
        customTitle: this.customTitle,
        metaDescription: this.metaDescription,
        customContent: this.editorContent,
        customFooter: this.editorFooter
      }

      categoryApi.update(this.$route.params.uuid, saveRequest).then(
        (response) => {
          Toastify({
            node: cash('#success-notification-content').clone().removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.$router.push({ name: 'superadmin-tools-category' })
        },
        (error) => {
          console.log(error)
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    }
  },
  computed: {
    console: () => console
  },
  mounted() {
    const lang = this.$route.params.lang
    categoryApi.getDetail(this.$route.params.uuid).then(
      (response) => {
        this.title = response.data.title[lang]
        this.customTitle = response.data.customTitle[lang] ?? ''
        this.metaDescription = response.data.metaDescription[lang] ?? ''
        this.editorContent = response.data.customContent[lang] ?? ''
        this.editorFooter = response.data.customFooter[lang] ?? ''
        this.loading = false
      },
      (error) => {
        console.log(error)
        Toastify({
          node: cash('#failed-load-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'superadmin-tools-category' })
      }
    )
  },
  setup() {
    const loading = ref(true)

    const title = ref('')
    const customTitle = ref('')
    const metaDescription = ref('')
    const editorTheme = ref('light')
    const editorContentRef = ref(null)
    const editorContent = ref('')
    const editorFooterRef = ref(null)
    const editorFooter = ref('')
    const editorOptions = computed(() => {
      return {
        toolbarItems: [
          [
            {
              name: 'h2',
              tooltip: 'Heading 2',
              command: 'heading2',
              text: 'H2',
              className: 'toastui-editor-toolbar-icons first',
              style: { backgroundImage: 'none' }
            },
            {
              name: 'h3',
              tooltip: 'Heading 3',
              command: 'heading3',
              text: 'H3',
              className: 'toastui-editor-toolbar-icons first',
              style: { backgroundImage: 'none' }
            },
            'bold',
            'italic',
            'strike'
          ],
          ['hr', 'quote'],
          ['ul', 'ol', 'task'],
          ['table', 'link'],
          ['code', 'codeblock']
        ],
        hooks: {
          addImageBlobHook: (blob, callback) => {
            alert('Image uploads are disabled in this editor.')
            return false
          }
        }
      }
    })

    return {
      title,
      customTitle,
      metaDescription,
      editorContentRef,
      editorFooterRef,
      editorFooter,
      editorTheme,
      editorContent,
      editorOptions,
      loading
    }
  }
})
</script>
